import { Injectable } from '@angular/core';
import { AppConfigService } from '../../app-config.service';
import { FeatureToggleModele } from '../modeles/feature-toggle.modele';
import { coerceArray } from '@angular/cdk/coercion';
import { find, get } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  constructor(private readonly _appConfigService: AppConfigService) {}

  private get enabledFeatures(): Array<FeatureToggleModele> {
    return get(this._appConfigService, 'configData.toggles', []);
  }

  hasFeatures(desiredFeatures: FeatureToggleModele | Array<FeatureToggleModele>): boolean {
    return (
      !!desiredFeatures &&
      coerceArray(desiredFeatures).every(desiredFeature => find(this.enabledFeatures, desiredFeature))
    );
  }

  hasSomeFeatures(desiredFeatures: FeatureToggleModele | Array<FeatureToggleModele>): boolean {
    return (
      !!desiredFeatures &&
      coerceArray(desiredFeatures).some(desiredFeature => find(this.enabledFeatures, desiredFeature))
    );
  }
}
